var exports = {
  "kL": "x804f0401--2b9c75--container",
  "wx": "x804f0401--2b9c75--header",
  "VN": "x804f0401--2b9c75--close",
  "Qs": "x804f0401--2b9c75--content",
  "hJ": "x804f0401--2b9c75--counter",
};

module.exports = exports;
